// https://sp.circlechess.com/v1/generate_payment_links

import {useMutation} from '@tanstack/react-query';
import ChessPaymentRestClient from '@/Api/ChessPaymentRestClient';

interface CartItem {
  tournament_id?: number;
  player_id?: number;
  category_str?: string;
  selected_tournament_ids?: number[];
}

interface PaymentApiParams {
  tournament_id?: number;
  player_id?: number;
  category_str?: string;
  customer_id: any;
  mobile_number: any;
  email: string;
  subscription_plan_id?: number;
  amount?: number;
  return_url: string;
  child_tournament_id?: number;
  cart_items?: CartItem[];
  coupon_code?: string;
  currency?: string;
  billing_address_first_name?: string;
  billing_address_last_name?: string;
  billing_address_line1?: string;
  billing_address_country?: string;
  payment_method_type?: string;
}

export default function useGeneratePaymentApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, PaymentApiParams>(
    async body => {
      const {amount = 100, cart_items, ...rest} = body;
      const endpoint =
        amount > 0
          ? 'v1/generate_payment_links'
          : 'v1/confirm_registration_without_payment';

      const payload = cart_items
        ? {
            mobile_number: rest.mobile_number,
            customer_id: rest.customer_id,
            email: rest.email,
            return_url: rest.return_url,
            cart_items,
            ...(rest.currency ? {currency: rest.currency} : {}),
            ...(rest.coupon_code ? {coupon_code: rest.coupon_code} : {}),
            ...(rest.billing_address_first_name
              ? {billing_address_first_name: rest.billing_address_first_name}
              : {}),
            ...(rest.billing_address_last_name
              ? {billing_address_last_name: rest.billing_address_last_name}
              : {}),
            ...(rest.billing_address_line1
              ? {billing_address_line1: rest.billing_address_line1}
              : {}),
            ...(rest.billing_address_country
              ? {billing_address_country: rest.billing_address_country}
              : {}),
            ...(rest.payment_method_type
              ? {payment_method_type: rest.payment_method_type}
              : {}),
          }
        : rest;

      const response = await ChessPaymentRestClient.post(endpoint, payload);
      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
